import history from "Services/history";
import { geoAggregations, communityValues, censusYears } from "Data";
import lifecycle from "recompose/lifecycle";
import { state } from "State";
import simplifyName from "Utils/simplifyName";

export default lifecycle({
  componentWillReceiveProps(newProps) {
    this.updateStateIfParamsDiverge(newProps);
  },
  componentWillMount() {
    this.updateStateIfParamsDiverge(this.props);
  },
  updateStateIfParamsDiverge(newProps) {
    let domain_data = state.get("domain_data");
    let paramsDivergeFromState = Object.keys(newProps.match.params).reduce(
      (memo, key) =>
        memo ||
        (key == "geo_aggregation_value"
          ? simplifyName(domain_data[key])
          : domain_data[key]) !== newProps.match.params[key],
      false
    );

    // all good so do nothing
    if (!paramsDivergeFromState) return;

    // check for community_value sanity
    // redirect to root if no community_value is defined
    if (newProps.match.params.community) {
      if (
        !newProps.match.params.community_value ||
        communityValues[newProps.match.params.year][
          newProps.match.params.community
        ].indexOf(newProps.match.params.community_value) == -1
      ) {
        history.push("/");
        return;
      }
    }

    // check sanity of years
    if (!censusYears.includes(newProps.match.params.year)) {
      history.push("/");
      return;
    }

    // check for geo_aggregation_value sanity
    // redirect to root if no geo_aggregation_value is defined
    let real_aggregation_value;
    if (newProps.match.params.geo_aggregation) {
      if (!newProps.match.params.geo_aggregation_value) {
        history.push("/");
        return;
      }

      real_aggregation_value = geoAggregations[domain_data.year][
        newProps.match.params.geo_aggregation
      ].find(
        _geo =>
          simplifyName(_geo) == newProps.match.params.geo_aggregation_value
      );

      if (!real_aggregation_value) {
        history.push("/");
        return;
      }
    }

    state.select("domain_data").merge(
      real_aggregation_value
        ? Object.assign({}, newProps.match.params, {
            geo_aggregation_value: real_aggregation_value
          })
        : newProps.match.params
    );

    if (newProps.match.params.community_value) {
      state
        .select(["ui", "community_search_input"])
        .set(newProps.match.params.community_value);
    }
  }
});



// WEBPACK FOOTER //
// ./components/SetStateFromRoute.js